import ImageDisplay from './ImageDisplay';
import { truncate } from '../data/functions';

function ProfileRow({ profile = {}, size = 'md', subtitle, boldSubtitle = false, boldName = false, profileStyle, customBorder }) {
  const sizeClasses = {
    xs: 'h-[26px] w-[26px] text-[10px]',
    sm: 'h-6 w-6 text-xs',
    md: 'h-10 w-10 text-base',
    lg: 'h-12 w-12 text-lg',
  };

  const imageSize = sizeClasses[size] || sizeClasses.md;

  const borderClass = profileStyle === 'purple' ? 'border-2' : '';

  return (
    <div className={`flex items-center ${size === 'xs' ? 'gap-1' : 'gap-3'}`}>
      <div
        className={`${imageSize} shrink-0 rounded-full bg-muted relative overflow-hidden ${borderClass}`}
        style={customBorder}
      >
        {profile?.images?.[0] && (
          <div className="absolute inset-0">
            <ImageDisplay
              imageData={profile.images[0]}
              imageStrategy="cover"
              className="h-full w-full rounded-full"
              showIcons={false}
            />
          </div>
        )}
      </div>
      <div className="flex-1 min-w-0 leading-tight">
        <div className={`${size === 'xs' ? 'text-[7.5px]' : 'text-sm'} ${boldName ? 'font-semibold' : 'font-medium'}`}>{truncate(profile?.name || 'Unknown')}</div>
        {subtitle && (
          <div className={`${size === 'xs' ? 'text-[6.75px]' : 'text-xs'} ${boldSubtitle ? 'text-foreground' : 'text-muted-foreground'}`}>
            {subtitle}
          </div>
        )}
      </div>
    </div>
  );
}

export default ProfileRow;
